import React from 'react'
import PropTypes from 'prop-types'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { uploadConfig } from 'utils'
import styles from './EssayWithSubitems.module.scss'

class EssayWithSubitems extends React.Component {
  state = {
    subItems: [{ id: new Date().getTime(), text: '' }],
  }

  onChange = (index, editor) => {
    const subItem = this.state.subItems.slice()
    subItem[index].text = editor.getData()
    this.setState({ subItems: subItem })
    this.props.callback({ options: this.state.subItems })
  }

  addMoreSubItem = () => {
    const newSubItem = [...this.state.subItems, { id: new Date().getTime(), text: '' }]
    this.setState({ subItems: newSubItem }, () =>
      this.props.callback({ options: this.state.subItems }),
    )
  }

  removeSubItem = event => {
    const array = [...this.state.subItems]
    array.splice(event.target.value, 1)
    this.setState({ subItems: array }, () => this.props.callback({ options: this.state.subItems }))
  }

  render() {
    return (
      <div className={styles['essay-subitems']}>
        {this.state.subItems.map((subItem, index) => (
          <div key={subItem.id}>
            <label>Subitem</label>
            <div className={styles['margin-top']}>
              <CKEditor
                editor={window.ClassicEditor}
                config={uploadConfig}
                onChange={(_, editor) => this.onChange(index, editor)}
              />
            </div>
            {this.state.subItems.length > 1 && (
              <div className={styles['div-button']}>
                <button
                  className={styles['button-delete']}
                  type='button'
                  value={index}
                  onClick={this.removeSubItem}
                >
                  Remover
                </button>
              </div>
            )}
          </div>
        ))}
        <button type='button' className={styles['button-add']} onClick={this.addMoreSubItem}>
          + item
        </button>
      </div>
    )
  }
}

EssayWithSubitems.propTypes = {
  callback: PropTypes.func,
}
export default EssayWithSubitems
